// src/components/bot/questions/TextQuestion.tsx
// 🎨 TEXT QUESTION COMPONENT - For general text input
// ✅ UPDATED: Removed placeholder and maxLength fields

import React from 'react';
import BaseQuestion from './BaseQuestion';
import styles from './Questions.module.css';
import { QuestionItem } from '../hooks/useBotForm';
import logger from '../../../utils/logger';

interface TextQuestionProps {
  question: QuestionItem;
  index: number;
  onUpdate: (id: string, field: keyof QuestionItem, value: any) => void;
  onRemove: (id: string) => void;
  onMoveUp: () => void;
  onMoveDown: () => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
  forceCollapsed?: boolean;
}

const TextQuestion: React.FC<TextQuestionProps> = (props) => {
  const { question } = props;

  logger.log('📝 TextQuestion: Rendering simplified text question:', question.id);

  return (
    <BaseQuestion {...props}>
      
      {/* ❌ REMOVED: typeSpecificOptions section - no more placeholder/maxLength */}
      
      {/* 🎯 TEXT QUESTION PREVIEW - Simplified */}
      <div className={styles.questionPreview}>
        <div className={styles.previewLabel}>Preview:</div>
        <div className={styles.previewContent}>
          <div className={styles.previewQuestion}>
            {question.question || 'Enter your question above...'}
            {question.required && <span className={styles.requiredAsterisk}>*</span>}
          </div>
          <div className={styles.previewInput}>
            <input 
              type="text"
              placeholder="User will type their answer here"
              disabled
              className={styles.previewInputField}
            />
          </div>
        </div>
      </div>
      
    </BaseQuestion>
  );
};

export default TextQuestion;